import { render } from "./CommonSubjectList.vue?vue&type=template&id=298b927d"
import script from "./CommonSubjectList.vue?vue&type=script&lang=js"
export * from "./CommonSubjectList.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\cbt-project\\candidate.dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__